import { Link } from 'react-router-dom';
import { Newspaper, ArrowRight } from 'lucide-react';
import './ArticleCard.css';

const API_URL = process.env.REACT_APP_API_URL;

/** Carte article réutilisée sur l'Accueil ("Dernières actualités") et le Blog. */
export function ArticleCard({ article }) {
  return (
    <Link to={`/blog/${article.slug}`} className="article-card">
      <div className="article-card__media">
        {article.image_couverture ? (
          <img src={`${API_URL}${article.image_couverture}`} alt="" loading="lazy" />
        ) : (
          <Newspaper className="article-card__media-icon" strokeWidth={1.5} />
        )}
        {article.categorie_nom && <span className="article-card__tag">{article.categorie_nom}</span>}
      </div>
      <div className="article-card__body">
        <h3 className="article-card__title">{article.titre}</h3>
        {article.extrait && <p className="article-card__excerpt">{article.extrait}</p>}
        <span className="article-card__link">
          Lire l'article <ArrowRight size={15} />
        </span>
      </div>
    </Link>
  );
}
